import { SubscriptionPlanDetailsDto } from '../../dto/subscriptionplandetails/subscriptionplandetailsdto';
import { APIResponse, APIResponseDtoImpl } from '../apiresponse';

export interface SubscriptionPlanDetailsResponse extends APIResponse
{
    getSubscriptionPlanDetailsDtos(): SubscriptionPlanDetailsDto;
}

export class SubscriptionPlanDetailsResponseDtoImpl extends APIResponseDtoImpl implements SubscriptionPlanDetailsResponse
{
    private subscriptionPlanDetailsDtos : SubscriptionPlanDetailsDto;

    getSubscriptionPlanDetailsDtos(): SubscriptionPlanDetailsDto
    {
        return this.subscriptionPlanDetailsDtos;
    }
    setSubscriptionPlanDetailsDtos(subscriptionPlanDetailsDtos: SubscriptionPlanDetailsDto)
    {
        this.subscriptionPlanDetailsDtos = subscriptionPlanDetailsDtos;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/subscriptionplandetails/subscriptionplandetailsresponse.tsx